var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"c-app-content is-sidebar-tiny"},[_c('custom-field',{attrs:{"type":"greenhub","label":"Loại rác"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }